import React, {} from "react";
import {Alert, Button, Stack} from "react-bootstrap";
import {AdminUserAlert, PageTitle, TextWithButtonLink} from "../../_components";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";
import {useGetJson, usePostJson,} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {useParams, Link, Routes, Route} from "react-router-dom";
import {useAuth} from "../../../context";
import {ProjectMap} from "../../../utils2/maps";
import {ConfigurationCard} from "./ConfigurationCard";
import {WhiteCard} from "../_components/WhiteCard";
import {useDelete} from "../../../hooks/useDelete";
import {NtpConfiguration} from "./NtpConfiguration";
import {ThirdPartyConfiguration} from "./ThirdPartyConfiguration";
import {ABBreadcrumbs} from "../_components/ABBreadcrumbs";

export function ConfigureDevice() {
    // return <DataFromServer/>
    return <>
        <Routes>
            <Route index element={<DataFromServer/>}/>

            <Route path="/ntp" element={<NtpConfiguration/>}/>
            <Route path="/third" element={<ThirdPartyConfiguration/>}/>
        </Routes>
    </>
}

function DataFromServer() {
    const {uid, did} = useParams()
    const {authToken} = useAuth()

    const [dev, loadingDevice, errorDevice, clearErrorDevice, setDevice] = useGetJson(endpoints.device.get(uid, did), authToken?.jwt)
    const device = dev?.data

    const initialValues = {
        controlled_ids: device?.controlled_ids || [],
        ntp: "",
        third: ""
    }

    return <>
        <Alert variant="danger" show={errorDevice} dismissible onClose={clearErrorDevice}>{errorDevice}</Alert>

        {loadingDevice && <div>Loading...</div>}

        <EditCategoryForm device={device} initialValues={initialValues} setDevice={setDevice}/>
    </>
}

function EditCategoryForm({device, initialValues, setDevice}) {
    const {uid, did} = useParams()
    const {authToken} = useAuth()

    const [sendData, v, postLoading, postError, clearPostError] = usePostJson(endpoints.device.edit(uid, did), authToken?.jwt)

    const [submitDelete, _, loadingDelete, errorDelete, clearErrorDelete] = useDelete(authToken?.jwt)

    const goBack = `/device/${uid}`

    // const validationSchema = yup.object().shape({})
    //
    // function handleSubmit(values) {
    //     console.log("submit edit", values)
    // }

    function handleDelete(selList) {
        selList.forEach(obj =>
            submitDelete(endpoints.event.del(obj.id), () =>
                setDevice(prev => ({...prev, data: {...prev.data, events: prev.data.events.filter(item => item.id !== obj.id)}})))
        )
    }

    return <>

        <AdminUserAlert/>
        <Alert variant="danger" show={postError} dismissible onClose={clearPostError}>{postError}</Alert>
        <Alert variant="danger" show={errorDelete} dismissible onClose={clearErrorDelete}>{errorDelete}</Alert>

        <ABBreadcrumbs breadcrumbList={[
            {name: "Your devices", shortName:"Devices", to: `/device/${uid}`},
            {name: "Configure Device", shortName:"Configure", to: `/device/${uid}/${did}/config`}]}
        />

        <PageTitle title="Configure">{device?.name}</PageTitle>

        {ProjectMap.find(p => p.project === device?.device_project)?.configure?.map((config, index) => (
            <ConfigurationCard key={index} configure={config} events={device?.events}
                               onDelete={handleDelete}/>))}

        <WhiteCard>
            <div className="fw-semibold fs-5">Additional Configurations</div>
            <TextWithButtonLink label="NTP" tip={device?.ntp ? `Selected: ${device?.ntp}` : "Configure NTP"} to="ntp"/>
            <TextWithButtonLink label="Third-Party" tip="Configure Third-Party API" to="third" disabled/>
        </WhiteCard>

        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
            <Button as={Link} variant="link" to={goBack}>Go back</Button>
            <Button as={Link} variant="primary" to={`/device/${uid}/${did}/dash`}>Dashboard</Button>
            {/*<Button type="submit" variant="primary" disabled={isSubmitting}>Edit</Button>*/}
        </Stack>

        {/*<Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={initialValues}*/}
        {/*        enableReinitialize={true}>*/}
        {/*    {({isSubmitting, values, errors, touched}) => (*/}
        {/*        <FormikForm>*/}

        {/*        </FormikForm>*/}
        {/*    )}*/}
        {/*</Formik>*/}

    </>
}
